import React, { Component } from 'react';

import classes from './AdminSettings.module.css';

import SmallTriangleDown from '../../UI/Buttons/SmallTriangleDown';
import SmallTriangleRight from '../../UI/Buttons/SmallTriangleRight';
import SettingsButton from '../../UI/Buttons/SettingsButton';
import ImageUploader from '../Sponsors/ImageUploader';
import ShoutboxControl from './ShoutboxControl';
import DataUploader from '../Calendar/DataUploader';
import Phonenumber from '../Information/phonenumber';
import StreamUrlEditor from '../Information/StreamUrlEditor';


class AdminSettings extends Component{

    render() {
        return(
            <div className={classes.settings}>
                <h3>{this.props.functionality}</h3>
                {this.props.show ? <SettingsButton click={this.props.click}><SmallTriangleDown/></SettingsButton> : <SettingsButton click={this.props.click}><SmallTriangleRight/></SettingsButton>}
                {(this.props.setting === 'sponsor' && this.props.show) ? <ImageUploader/> : null}
                {(this.props.setting === 'shoutbox' && this.props.showShoutbox) ? <ShoutboxControl/> : null}
                {(this.props.setting === 'calendar' && this.props.showCalendar) ? <DataUploader/> : null}
                {(this.props.setting === 'phonenumber' && this.props.show) ? <Phonenumber onSuccess={this.props.onSuccess}/> : null}
                {(this.props.setting === 'streamUrl' && this.props.show) ? <StreamUrlEditor onSuccess={this.props.onSuccess}/> : null}
            </div>
        );
    }
}

export default AdminSettings;